<template>
  <div class="user-profile-page">
    <!-- 用户信息卡片 -->
    <div class="profile-header">
      <div class="profile-avatar">👤</div>
      <div class="profile-info">
        <!-- <div class="profile-name">{{ userInfo?.nickName || '昵称' }}</div>
        <div class="profile-phone">{{ userInfo?.phone || '未绑定手机' }}</div> -->
        <div class="profile-name">{{ userInfo?.phone || '未绑定手机' }}</div>
      </div>
    </div>

    <!-- 菜单列表 -->
    <div class="profile-menu">
      <div class="menu-item" @click="goToOrderList">
        <div class="menu-icon">📋</div>
        <div class="menu-text">我的订单</div>
        <div class="menu-arrow">›</div>
      </div>

      <div class="menu-item" @click="goToTravelerList">
        <div class="menu-icon">✈️</div>
        <div class="menu-text">出行人管理</div>
        <div class="menu-arrow">›</div>
      </div>

      <div class="menu-item" @click="goToArticleList">
        <div class="menu-icon">📰</div>
        <div class="menu-text">资讯中心</div>
        <div class="menu-arrow">›</div>
      </div>
    </div>

    <!-- 其他功能 -->
    <div class="profile-section">
      <div class="section-title">其他</div>
      <div class="menu-item" @click="handleAbout">
        <div class="menu-icon">ℹ️</div>
        <div class="menu-text">关于我们</div>
        <div class="menu-arrow">›</div>
      </div>

      <div class="menu-item" @click="handleFeedback">
        <div class="menu-icon">💬</div>
        <div class="menu-text">意见反馈</div>
        <div class="menu-arrow">›</div>
      </div>
    </div>

    <!-- 退出登录：merchantid=13 是三方合作伙伴 JWT 免密登录场景，不允许用户在 H5 内主动退出登录 -->
    <div v-if="!isPartnerAutoLoginMerchant" class="profile-footer">
      <button class="logout-btn" @click="handleLogout">退出登录</button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getUrlMerchantId } from '@/utils/storage'

export default {
  name: 'UserProfile',
  computed: {
    ...mapState('user', ['userInfo']),
    isPartnerAutoLoginMerchant() {
      return getUrlMerchantId() === '13'
    }
  },
  methods: {
    goToOrderList() {
      this.$router.push('/orders')
    },
    goToTravelerList() {
      this.$router.push('/traveler')
    },
    goToArticleList() {
      this.$router.push('/articles')
    },
    handleAbout() {
      this.$alert('Sweetour \n\n版本：1.0.0\n\n一站式旅游服务平台')
    },
    handleFeedback() {
      this.$router.push('/user/feedback')
    },
    async handleLogout() {
      const ok = await this.$confirm('确定要退出登录吗？')
      if (ok) {
        const mid = localStorage.getItem('sweetour_url_merchant_id')
        this.$store.dispatch('user/logout')
        this.$router.push(mid ? `/login?merchantid=${mid}` : '/login')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.user-profile-page {
  width: 100%;
  min-height: 100vh;
  background: #f9fafb;
}

.profile-header {
  background: linear-gradient(135deg, #ffa43a 0%, #ff720d 58%, #e85d04 100%);
  color: #fff;
  padding: 40px 16px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.profile-avatar {
  font-size: 48px;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(255, 255, 255, 0.2);
  border-radius: 50%;
}

.profile-info {
  flex: 1;
}

.profile-name {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 4px;
}

.profile-phone {
  font-size: 14px;
  opacity: 0.9;
}

.profile-menu {
  background: #fff;
  margin: 12px 0;
}

.profile-section {
  background: #fff;
  margin: 12px 0;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: #6b7280;
  padding: 12px 16px;
  background: #f9fafb;
}

.menu-item {
  display: flex;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #f3f4f6;
  transition: all 0.3s ease;

  &:last-child {
    border-bottom: none;
  }

  &:active {
    background: #f9fafb;
  }
}

.menu-icon {
  font-size: 24px;
  margin-right: 12px;
}

.menu-text {
  flex: 1;
  font-size: 14px;
  color: #111827;
  font-weight: 500;
}

.menu-arrow {
  font-size: 18px;
  color: #d1d5db;
}

.profile-footer {
  padding: 20px 16px;
}

.logout-btn {
  width: 100%;
  padding: 12px;
  background: #ef4444;
  color: #fff;
  border: none;
  border-radius: 8px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;

  &:active {
    opacity: 0.8;
  }
}
</style>
